import React from 'react';

const QR_SERVER = 'https://api.qrserver.com/v1/create-qr-code/';

export default function QrCode({ value, size = 160 }) {
  const url = `${QR_SERVER}?size=${size}x${size}&data=${encodeURIComponent(value)}`;

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: 'white', padding: '8px', borderRadius: '12px', border: '1px solid var(--gray-200)' }}>
      <img src={url} alt="QR code" width={size} height={size} style={{ display: 'block' }} />
    </div>
  );
}
